import { render, staticRenderFns } from "./ArticleThemes.vue?vue&type=template&id=36109bc6&"
import script from "./ArticleThemes.vue?vue&type=script&lang=ts&"
export * from "./ArticleThemes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports